import affiliatesFragment from './Search/affiliates';
import facetsLimitedFragment from './Search/limited';
import { mediaFragment } from './Search/mediaFragment';
import { costBreakdownFragment } from './Shared/costBreakdownFragment';

const fragment = () => {
	return `
    fragment ProfileProperties on Storefront {
      id
      vendorId
      accountId
      accountStatus
      name
      bio {
        name
        description
        displayRole
        photo {
          id
          url
        }
      }
      displayId
      isTestData
      ivolScoreId
      adTier
      claimedStatus
      marketCode
      movedProfileId
      purchaseStatus
      vendorTier
      isNew
      dek {
        description
      }
      addOns {
        code
      }
      affiliates {
        id
        name
        description
        singular {
          slug
          term
        }
        plural {
          slug
          term
        }
        isSelected
        ...AffiliatesRecurse
      }
      ai {
        photo {
          height
          id
          mediaType
          url
          width
        }
      }
      categories {
        id
        code
        name
        displayName
      }
      categoryInfo {
        plural {
          slug
          term
        }
      }
      facets {
        id
        name
        ...FacetsRecurseLimited
      }
      location {
        address {
          address1
          address2
          city
          state
          postalCode
          latitude
          longitude
          isPublic
        }
        serviceArea
      }
      logo {
        url
      }
      mediaSummary {
        total
        media {
          ...MediaItems
        }
      }
      pricing {
        cost {
          gte
          lte
        }
      }
      reviewSummary {
        count
        overallRating
      }
      salesProfiles {
        vendorTier
        marketCode
        addOns {
          code
          name
        }
      }
      settings {
        AIPhoto
        peaceOfMindEligible
      }
      siteUrls {
        siteId
        siteName
        uri
        relativeUri
      }
      statistics {
        completionScore
        ivolScore
      }
      storefrontCard {
        id
        mediaType
        url
      }
      vendorBehavior {
        quickResponder
      }
      complete
      deals {
        items {
          id
          title
          description
          endDate
          discount
          type
        }
      }
  }
  ${affiliatesFragment}
  ${facetsLimitedFragment}
  ${mediaFragment}
  `;
};

export const personalizedSortFragment = `
    fragment PersonalizedSortProfileProperties on Storefront {
      id
      vendorId
      accountId
      accountStatus
      name
      bio {
        name
        description
        displayRole
        photo {
          id
          url
        }
      }
      displayId
      isTestData
      adTier
      claimedStatus
      marketCode
      movedProfileId
      personalizedScoreId
      purchaseStatus
      vendorTier
      isNew
      dek {
        description
      }
      addOns {
        code
      }
      affiliates {
        id
        name
        description
        singular {
          slug
          term
        }
        plural {
          slug
          term
        }
        isSelected
        ...AffiliatesRecurse
      }
      ai {
        photo {
          height
          id
          mediaType
          url
          width
        }
        recommendedPhoto {
          height
          id
          mediaType
          url
          width
        }
        reviewSummaryGenerated {
          summaryText
          summaryId
        }
        costBreakdown {
          ...AiCostBreakdownParts
        }
      }
      categories {
        id
        code
        name
        displayName
      }
      categoryInfo {
        plural {
          slug
          term
        }
      }
      facets {
        id
        name
        ...FacetsRecurseLimited
      }
      orgDetails {
        videographyServices
      }
      location {
        address {
          address1
          address2
          city
          state
          postalCode
          latitude
          longitude
          isPublic
        }
        serviceArea
      }
      logo {
        url
      }
      mediaSummary {
        total
        media {
          ...MediaItems
        }
      }
      pricing {
        peak {
          min {
            value
          }
        }
        offPeak {
          min {
            value
          }
        }
        cost {
          gte
          lte
        }
      }
      reviewSummary {
        count
        overallRating
      }
      salesProfiles {
        vendorTier
        marketCode
        addOns {
          code
          name
        }
      }
      settings {
        AIPhoto
        peaceOfMindEligible
      }
      siteUrls {
        siteId
        siteName
        uri
        relativeUri
      }
      statistics {
        completionScore
        personalizedScore
        sssOrder
        videoCount
        tourCount
      }
      storefrontCard {
        id
        mediaType
        url
      }
      vendorBehavior {
        quickResponder
        nonResponsive
      }
      complete
      freshContent
      deals {
        items {
          id
          title
          description
          endDate
          discount
          type
        }
      }
  }
  ${affiliatesFragment}
  ${facetsLimitedFragment}
  ${mediaFragment}
  ${costBreakdownFragment}
  `;

export default fragment;
